export default "__VITE_ASSET__dPuc7zzV__"